import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'system/';

export default {
  // Get all system defaults
  getDefaults: () => {
    return api.get(`${BASE_URL}`);
  },

  // Update the default commission
  updateCommission: (commission) => {
    return api.put(`${BASE_URL}commission`, { commission });
  }
};
